import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import CountryCreatePage from './country-create'
import CountryListPage from './country-list'
import UpdateCountryPage from './country-update'

const countryRoutes: Route[] = [
  {
    path: Paths.COUNTRY_LIST_PAGE,
    element: <CountryListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.COUNTRY_CREATE_PAGE,
    element: <CountryCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.COUNTRY_UPDATE_PAGE,
    element: <UpdateCountryPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default countryRoutes
